















import Vue from 'vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { events } from './utils';
import { OPEN_CONFIRM_EVENT, CLOSE_CONFIRM_EVENT } from './constants';
import type { ConfirmPayload } from './types';
import ConfirmDialog from '~/components/common/ConfirmDialog.vue';

const DEFAULT_ACTION_NAME = 'Remove';

export default Vue.extend({
  name: 'Confirm',
  components: {
    ConfirmDialog,
    BravadoButtonV3,
  },
  data(): ConfirmPayload & { name: string } {
    return {
      name: 'confirm',
      variant: 'danger',
      action: DEFAULT_ACTION_NAME,
      title: null,
      hint: null,
      resolve: undefined,
      reject: undefined,
    };
  },
  beforeMount() {
    events.$on(OPEN_CONFIRM_EVENT, this.open);
    events.$on(CLOSE_CONFIRM_EVENT, this.close);
  },
  beforeDestroy() {
    events.$off(OPEN_CONFIRM_EVENT, this.open);
    events.$off(CLOSE_CONFIRM_EVENT, this.close);
  },
  methods: {
    open({
      action = DEFAULT_ACTION_NAME,
      title = null,
      hint = null,
      variant = 'danger',
      resolve,
      reject,
    }: ConfirmPayload) {
      this.action = action;
      this.title = title;
      this.hint = hint;
      this.variant = variant;

      this.$nextTick(() => {
        this.$modal.show(this.name);
      });

      this.resolve = resolve;
      this.reject = reject;
    },
    close() {
      this.$modal.hide(this.name);
    },
    handleAction() {
      this.resolve && this.resolve();
      this.close();
    },
    handleCancel() {
      this.reject && this.reject(new Error('Action has been cancelled'));
      this.close();
    },
  },
});
